import { usePublicDiscountData } from "./usePublicDiscountData";
import { useEffect, useState } from "react";
import { PUBLIC_DISCOUNT_KEYS } from "@iscr/constants";

const getValueString = (discountData, itemKey) => {
  if (discountData && discountData[itemKey]) {
    const discount = discountData[itemKey];
    return `${discount.amount}${discount.rule === "percentage" && "%"}`;
  }
  return null;
};

export const useOnePassDiscountStrings = () => {
  const [onepassDiscountStrings, setOnepassDiscountStrings] = useState(null);
  const publicDiscountData = usePublicDiscountData();
  useEffect(() => {
    if (publicDiscountData) {
      const onePassDiscountValue = getValueString(
        publicDiscountData,
        PUBLIC_DISCOUNT_KEYS.ONE_PASS
      );
      const firstTimeDiscount = getValueString(
        publicDiscountData,
        PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST
      );
      const strings = {
        [PUBLIC_DISCOUNT_KEYS.ONE_PASS]: onePassDiscountValue,
        [PUBLIC_DISCOUNT_KEYS.ONE_PASS_FIRST]: firstTimeDiscount,
      };
      setOnepassDiscountStrings(strings);
    }
  }, [publicDiscountData, setOnepassDiscountStrings]);
  return onepassDiscountStrings;
};
